import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';
import dataService, { type IResponse } from 'services/dataService';
import { apiUnassignTask } from 'services/dataService/resources/oneplatform/api';

import { getTasksByPatientQueryKey } from './use-get-tasks-by-patient';

import type { ITaskCard, IUnassignTaskPayload } from '../types';

export const useUnassignTask = (patientGuid: string) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({
      taskGuid,
      returnNote,
    }: { taskGuid: string } & IUnassignTaskPayload) =>
      dataService.createOne<{ task: ITaskCard }>(apiUnassignTask(taskGuid), {
        returnNote,
      }),
    onSuccess: (response: IResponse<{ task: ITaskCard }>) => {
      if (response.error) {
        notificationController.error({
          message: t('tasksDrawer.returnError'),
        });
        return;
      }

      notificationController.success({
        message: t('tasksDrawer.returnSuccess'),
      });
      queryClient.invalidateQueries(getTasksByPatientQueryKey(patientGuid));
    },
  });
};
